/**
 * Do not edit directly
 * Generated on Tue, 30 Sep 2025 08:34:57 GMT
 */

export const legacyTagBackgroundBasicBold = "hsl(240, 21%, 90%)";
export const legacyTagBackgroundPrimary = "hsl(240, 100%, 95%)";
export const legacyTagBackgroundDenim = "hsl(206, 47%, 93%)";
export const legacyTagBackgroundLime = "hsl(125, 30%, 92%)";
export const legacyTagBackgroundMustard = "hsl(45, 80%, 94%)";
export const legacyTagBackgroundLavender = "hsl(258, 38%, 95%)";
export const legacyTagBackgroundRuby = "hsl(350, 64%, 95%)";
export const legacyTagBackgroundTangerine = "hsl(20, 75%, 95%)";
export const legacyTagTextBasicBold = "hsl(240, 15%, 30%)";
export const legacyTagTextPrimary = "hsl(241, 88%, 58%)";
export const legacyTagTextDenim = "hsl(212, 77%, 31%)";
export const legacyTagTextLime = "hsl(123, 71%, 20%)";
export const legacyTagTextMustard = "hsl(240, 16%, 15%)";
export const legacyTagTextLavender = "hsl(252, 42%, 41%)";
export const legacyTagTextRuby = "hsl(354, 76%, 42%)";
export const legacyTagTextTangerine = "hsl(240, 16%, 15%)";
export const legacyTagBorderBasicBold = "hsl(240, 16%, 61%)";
export const legacyTagBorderPrimary = "hsl(241, 94%, 72%)";
export const legacyTagBorderDenim = "hsl(205, 59%, 44%)";
export const legacyTagBorderLime = "hsl(125, 53%, 35%)";
export const legacyTagBorderMustard = "hsl(45, 83%, 52%)";
export const legacyTagBorderLavender = "hsl(255, 37%, 57%)";
export const legacyTagBorderRuby = "hsl(350, 65%, 54%)";
export const legacyTagBorderTangerine = "hsl(20, 79%, 61%)";
export const legacyDatavizDenim50 = "hsl(206, 47%, 93%)";
export const legacyDatavizDenim100 = "hsl(206, 47%, 83%)";
export const legacyDatavizDenim200 = "hsl(205, 46%, 72%)";
export const legacyDatavizDenim300 = "hsl(205, 46%, 61%)";
export const legacyDatavizDenim400 = "hsl(205, 47%, 52%)";
export const legacyDatavizDenim500 = "hsl(205, 59%, 44%)";
export const legacyDatavizDenim600 = "hsl(206, 61%, 42%)";
export const legacyDatavizDenim700 = "hsl(207, 64%, 39%)";
export const legacyDatavizDenim800 = "hsl(209, 68%, 36%)";
export const legacyDatavizDenim900 = "hsl(212, 77%, 31%)";
export const legacyDatavizLavender50 = "hsl(258, 38%, 95%)";
export const legacyDatavizLavender100 = "hsl(255, 36%, 87%)";
export const legacyDatavizLavender200 = "hsl(255, 37%, 79%)";
export const legacyDatavizLavender300 = "hsl(255, 37%, 70%)";
export const legacyDatavizLavender400 = "hsl(255, 37%, 64%)";
export const legacyDatavizLavender500 = "hsl(255, 37%, 57%)";
export const legacyDatavizLavender600 = "hsl(255, 35%, 54%)";
export const legacyDatavizLavender700 = "hsl(254, 33%, 51%)";
export const legacyDatavizLavender800 = "hsl(254, 36%, 47%)";
export const legacyDatavizLavender900 = "hsl(252, 42%, 41%)";
export const legacyDatavizLime50 = "hsl(125, 30%, 92%)";
export const legacyDatavizLime100 = "hsl(126, 28%, 80%)";
export const legacyDatavizLime200 = "hsl(125, 28%, 67%)";
export const legacyDatavizLime300 = "hsl(126, 28%, 54%)";
export const legacyDatavizLime400 = "hsl(125, 35%, 45%)";
export const legacyDatavizLime500 = "hsl(125, 53%, 35%)";
export const legacyDatavizLime600 = "hsl(125, 55%, 32%)";
export const legacyDatavizLime700 = "hsl(125, 58%, 29%)";
export const legacyDatavizLime800 = "hsl(124, 62%, 26%)";
export const legacyDatavizLime900 = "hsl(123, 71%, 20%)";
export const legacyDatavizMustard50 = "hsl(45, 80%, 94%)";
export const legacyDatavizMustard100 = "hsl(44, 84%, 86%)";
export const legacyDatavizMustard200 = "hsl(45, 84%, 76%)";
export const legacyDatavizMustard300 = "hsl(45, 83%, 66%)";
export const legacyDatavizMustard400 = "hsl(45, 83%, 59%)";
export const legacyDatavizMustard500 = "hsl(45, 83%, 52%)";
export const legacyDatavizMustard600 = "hsl(44, 81%, 51%)";
export const legacyDatavizMustard700 = "hsl(42, 82%, 49%)";
export const legacyDatavizMustard800 = "hsl(41, 85%, 48%)";
export const legacyDatavizMustard900 = "hsl(38, 91%, 45%)";
export const legacyDatavizTangerine50 = "hsl(20, 75%, 95%)";
export const legacyDatavizTangerine100 = "hsl(19, 80%, 88%)";
export const legacyDatavizTangerine200 = "hsl(20, 80%, 81%)";
export const legacyDatavizTangerine300 = "hsl(20, 79%, 73%)";
export const legacyDatavizTangerine400 = "hsl(20, 79%, 67%)";
export const legacyDatavizTangerine500 = "hsl(20, 79%, 61%)";
export const legacyDatavizTangerine600 = "hsl(19, 77%, 59%)";
export const legacyDatavizTangerine700 = "hsl(18, 76%, 57%)";
export const legacyDatavizTangerine800 = "hsl(17, 74%, 54%)";
export const legacyDatavizTangerine900 = "hsl(15, 72%, 50%)";
export const legacyDatavizRuby50 = "hsl(350, 64%, 95%)";
export const legacyDatavizRuby100 = "hsl(351, 66%, 86%)";
export const legacyDatavizRuby200 = "hsl(350, 66%, 77%)";
export const legacyDatavizRuby300 = "hsl(350, 65%, 68%)";
export const legacyDatavizRuby400 = "hsl(350, 65%, 61%)";
export const legacyDatavizRuby500 = "hsl(350, 65%, 54%)";
export const legacyDatavizRuby600 = "hsl(350, 63%, 52%)";
export const legacyDatavizRuby700 = "hsl(351, 63%, 49%)";
export const legacyDatavizRuby800 = "hsl(352, 67%, 46%)";
export const legacyDatavizRuby900 = "hsl(354, 76%, 42%)";
export const backgroundStaticFlat = "hsl(0, 0%, 100%)";
export const backgroundStaticRaised = "hsl(0, 0%, 100%)";
export const backgroundStaticFloating = "hsl(0, 0%, 100%)";
export const backgroundStaticSunken = "hsl(0, 0%, 95%)";
export const backgroundStaticInverse = "hsl(240, 16%, 15%)";
export const backgroundStaticOnColor = "hsl(0, 0%, 100%)";
export const backgroundStaticInverseOnColor = "hsl(240, 16%, 15%)";
export const backgroundInteractivePrimaryDefault = "hsl(241, 88%, 58%)";
export const backgroundInteractivePrimaryHover = "hsl(241, 84%, 46%)";
export const backgroundInteractivePrimaryActive = "hsl(241, 91%, 35%)";
export const backgroundInteractiveSecondaryDefault = "hsl(240, 100%, 98%)";
export const backgroundInteractiveSecondaryHover = "hsl(240, 100%, 95%)";
export const backgroundInteractiveSecondaryActive = "hsl(240, 96%, 90%)";
export const backgroundInteractiveDangerDefault = "hsl(0, 78%, 50%)";
export const backgroundInteractiveDangerHover = "hsl(0, 86%, 44%)";
export const backgroundInteractiveDangerActive = "hsl(5, 93%, 33%)";
export const backgroundInteractiveNeutralSubtleDefault = "hsl(0, 0%, 100%)";
export const backgroundInteractiveNeutralSubtleHover = "hsla(240, 16%, 61%, 0.08)";
export const backgroundInteractiveNeutralSubtleActive = "hsla(240, 16%, 61%, 0.16)";
export const backgroundInteractiveNeutralDefault = "hsl(240, 23%, 95%)";
export const backgroundInteractiveNeutralHover = "hsl(240, 21%, 90%)";
export const backgroundInteractiveNeutralActive = "hsl(240, 19%, 80%)";
export const backgroundInteractiveNeutralBoldDefault = "hsl(240, 13%, 53%)";
export const backgroundInteractiveNeutralBoldHover = "hsl(240, 13%, 45%)";
export const backgroundInteractiveNeutralBoldActive = "hsl(240, 14%, 37%)";
export const backgroundInteractiveSuccessDefault = "hsl(115, 41%, 37%)";
export const backgroundInteractiveSuccessHover = "hsl(118, 40%, 31%)";
export const backgroundInteractiveSuccessActive = "hsl(122, 37%, 26%)";
export const backgroundAlertWarningPrimary = "hsl(37, 90%, 54%)";
export const backgroundAlertWarningSecondary = "hsl(43, 81%, 94%)";
export const backgroundAlertSuccessPrimary = "hsl(112, 35%, 51%)";
export const backgroundAlertSuccessSecondary = "hsl(111, 58%, 95%)";
export const backgroundAlertInfoPrimary = "hsl(215, 92%, 60%)";
export const backgroundAlertInfoSecondary = "hsl(212, 100%, 95%)";
export const backgroundAlertDangerPrimary = "hsl(0, 87%, 63%)";
export const backgroundAlertDangerSecondary = "hsl(0, 89%, 96%)";
export const backgroundAlertBasicPrimary = "hsl(240, 14%, 37%)";
export const backgroundAlertBasicSecondary = "hsl(240, 23%, 97%)";
export const backgroundAccentPrimary = "hsl(241, 88%, 58%)";
export const backgroundAccentSecondary = "hsl(356, 97%, 72%)";
export const backgroundAccentBrand = "hsl(241, 94%, 72%)";
export const backgroundAccentInfo = "hsl(216, 82%, 52%)";
export const backgroundAccentDanger = "hsl(0, 84%, 56%)";
export const backgroundAccentSuccess = "hsl(115, 41%, 37%)";
export const backgroundAccentWarning = "hsl(34, 100%, 40%)";
export const backgroundAccentGradient = "hsl(240, 23%, 97%)";
export const backgroundDatavizBluePrimary = "hsl(216, 89%, 55%)";
export const backgroundDatavizBlueSecondary = "hsl(215, 89%, 89%)";
export const backgroundDatavizOrangePrimary = "hsl(22, 100%, 50%)";
export const backgroundDatavizOrangeSecondary = "hsl(22, 100%, 87%)";
export const backgroundDatavizGreenPrimary = "hsl(184, 100%, 32%)";
export const backgroundDatavizGreenSecondary = "hsl(184, 49%, 83%)";
export const backgroundDatavizRedPrimary = "hsl(356, 98%, 51%)";
export const backgroundDatavizRedSecondary = "hsl(355, 97%, 88%)";
export const backgroundDatavizPurplePrimary = "hsl(271, 68%, 43%)";
export const backgroundDatavizPurpleSecondary = "hsl(271, 51%, 86%)";
export const backgroundDatavizPinkPrimary = "hsl(324, 100%, 64%)";
export const backgroundDatavizPinkSecondary = "hsl(323, 100%, 91%)";
export const backgroundDatavizInfo = "hsl(216, 88%, 56%)";
export const backgroundDatavizSuccess = "hsl(111, 42%, 42%)";
export const backgroundDatavizWarning = "hsl(34, 100%, 40%)";
export const backgroundDatavizDanger = "hsl(0, 84%, 56%)";
export const backgroundDisabled = "hsl(240, 23%, 95%)";
export const backgroundBrand = "hsl(240, 16%, 15%)";
export const backgroundBackdrop = "hsla(240, 16%, 8%, 0.08)";
export const textStaticPrimary = "hsl(240, 16%, 15%)";
export const textStaticSecondary = "hsl(240, 14%, 37%)";
export const textStaticTertiary = "hsl(240, 13%, 45%)";
export const textStaticInverse = "hsl(0, 0%, 100%)";
export const textStaticOnColor = "hsl(0, 0%, 100%)";
export const textInteractivePrimaryDefault = "hsl(241, 88%, 58%)";
export const textInteractivePrimaryHover = "hsl(241, 84%, 46%)";
export const textInteractivePrimaryActive = "hsl(241, 91%, 35%)";
export const textInteractiveSecondaryDefault = "hsl(240, 16%, 15%)";
export const textInteractiveSecondaryHover = "hsl(240, 16%, 23%)";
export const textInteractiveSecondaryActive = "hsl(240, 15%, 30%)";
export const textAlertDanger = "hsl(0, 86%, 44%)";
export const textAlertWarning = "hsl(38, 100%, 30%)";
export const textAlertSuccess = "hsl(122, 37%, 26%)";
export const textAlertInfo = "hsl(216, 84%, 46%)";
export const textAlertBasic = "hsl(240, 14%, 37%)";
export const textDisabled = "hsl(240, 19%, 80%)";
export const borderStaticPrimary = "hsl(240, 21%, 90%)";
export const borderStaticSecondary = "hsl(240, 23%, 95%)";
export const borderStaticInverse = "hsl(0, 0%, 100%)";
export const borderStaticOnColor = "hsl(0, 0%, 100%)";
export const borderStaticTertiary = "hsl(240, 16%, 61%)";
export const borderInteractivePrimaryDefault = "hsl(241, 88%, 58%)";
export const borderInteractivePrimaryHover = "hsl(241, 84%, 46%)";
export const borderInteractivePrimaryActive = "hsl(241, 91%, 35%)";
export const borderInteractiveSecondaryDefault = "hsl(240, 19%, 80%)";
export const borderInteractiveSecondaryHover = "hsl(240, 16%, 61%)";
export const borderInteractiveSecondaryActive = "hsl(240, 13%, 53%)";
export const borderInteractiveBoldDefault = "hsl(240, 14%, 37%)";
export const borderInteractiveBoldHover = "hsl(240, 15%, 30%)";
export const borderInteractiveBoldActive = "hsl(240, 16%, 23%)";
export const borderInteractiveFocus = "hsl(241, 91%, 65%)";
export const borderInteractiveInputDefault = "hsl(240, 16%, 61%)";
export const borderInteractiveInputHover = "hsl(240, 13%, 53%)";
export const borderInteractiveInputActive = "hsl(240, 13%, 45%)";
export const borderInteractiveInputError = "hsl(0, 78%, 50%)";
export const borderAlertWarning = "hsl(40, 93%, 73%)";
export const borderAlertSuccess = "hsl(112, 47%, 77%)";
export const borderAlertInfo = "hsl(213, 97%, 77%)";
export const borderAlertDanger = "hsl(0, 90%, 84%)";
export const borderAlertBasic = "hsl(240, 19%, 80%)";
export const borderAccent = "hsl(0, 0%, 35%)";
export const borderDisabled = "hsl(240, 23%, 95%)";
export const borderBrand = "hsl(240, 16%, 23%)";
export const fontSizeBase = 14;
export const fontSizeRatio = 1.125;
export const fontSize50 = 11;
export const fontSize75 = 12;
export const fontSize100 = 14;
export const fontSize200 = 16;
export const fontSize300 = 18;
export const fontSize400 = 20;
export const fontSize500 = 22;
export const fontSize600 = 25;
export const fontSize700 = 28;
export const fontSize800 = 32;
export const fontSize900 = 36;
export const visualAssetsNeutralSubtle = "hsl(240, 23%, 97%)";
export const visualAssetsNeutralSubtle0 = "hsla(240, 23%, 97%, 0)";
export const visualAssetsNeutralBold = "hsl(0, 0%, 35%)";
export const visualAssetsNeutralBold0 = "hsla(0, 0%, 35%, 0)";
export const visualAssetsSemanticDanger = "hsl(0, 84%, 56%)";
export const visualAssetsSemanticWarning = "hsl(37, 90%, 54%)";
export const visualAssetsSemanticSuccess = "hsl(112, 35%, 51%)";
export const visualAssetsSemanticInfo = "hsl(216, 88%, 56%)";
export const visualAssetsAccent = "hsl(241, 94%, 72%)";
export const shadow0 = "0px 0px 0px 0px hsl(0, 0%, 0%)";
export const shadow100 = "0px 2px 6px -1px hsla(240, 16%, 8%, 0.08), 0px -1px 4px -2px hsla(240, 16%, 8%, 0.08)";
export const shadow200 = "0px 8px 24px -4px hsla(240, 16%, 8%, 0.08), 0px 6px 12px -6px hsla(240, 16%, 8%, 0.08)";
export const shadow300 = "0px 18px 88px -4px hsla(240, 16%, 8%, 0.12), 0px 12px 28px -6px hsla(240, 16%, 8%, 0.12)";
export const paletteBrandIndigo0 = "hsl(240, 100%, 99%)";
export const paletteBrandIndigo25 = "hsl(240, 100%, 98%)";
export const paletteBrandIndigo50 = "hsl(240, 100%, 95%)";
export const paletteBrandIndigo100 = "hsl(240, 96%, 90%)";
export const paletteBrandIndigo150 = "hsl(241, 95%, 85%)";
export const paletteBrandIndigo200 = "hsl(241, 96%, 81%)";
export const paletteBrandIndigo300 = "hsl(241, 94%, 72%)";
export const paletteBrandIndigo400 = "hsl(241, 91%, 65%)";
export const paletteBrandIndigo500 = "hsl(241, 88%, 58%)";
export const paletteBrandIndigo600 = "hsl(241, 82%, 52%)";
export const paletteBrandIndigo700 = "hsl(241, 84%, 46%)";
export const paletteBrandIndigo800 = "hsl(241, 91%, 35%)";
export const paletteBrandIndigo900 = "hsl(241, 96%, 21%)";
export const paletteBrandIndigo1000 = "hsl(241, 100%, 10%)";
export const paletteBrandNight0 = "hsl(0, 0%, 100%)";
export const paletteBrandNight25 = "hsl(240, 23%, 97%)";
export const paletteBrandNight50 = "hsl(240, 23%, 95%)";
export const paletteBrandNight100 = "hsl(240, 21%, 90%)";
export const paletteBrandNight150 = "hsl(240, 19%, 80%)";
export const paletteBrandNight200 = "hsl(240, 17%, 70%)";
export const paletteBrandNight300 = "hsl(240, 16%, 61%)";
export const paletteBrandNight400 = "hsl(240, 13%, 53%)";
export const paletteBrandNight500 = "hsl(240, 13%, 45%)";
export const paletteBrandNight600 = "hsl(240, 14%, 37%)";
export const paletteBrandNight700 = "hsl(240, 15%, 30%)";
export const paletteBrandNight800 = "hsl(240, 16%, 23%)";
export const paletteBrandNight900 = "hsl(240, 16%, 15%)";
export const paletteBrandNight1000 = "hsl(240, 16%, 8%)";
export const paletteBrandNight10008 = "hsla(240, 16%, 8%, 0.08)";
export const paletteBrandNight100012 = "hsla(240, 16%, 8%, 0.12)";
export const paletteBrandNight100016 = "hsla(240, 16%, 8%, 0.16)";
export const paletteBrandNight064 = "hsla(0, 0%, 100%, 0.64)";
export const paletteBrandCoral0 = "hsl(354, 100%, 98%)";
export const paletteBrandCoral25 = "hsl(355, 100%, 96%)";
export const paletteBrandCoral50 = "hsl(356, 100%, 91%)";
export const paletteBrandCoral100 = "hsl(356, 98%, 81%)";
export const paletteBrandCoral150 = "hsl(356, 97%, 72%)";
export const paletteBrandCoral200 = "hsl(356, 98%, 63%)";
export const paletteBrandCoral300 = "hsl(356, 100%, 49%)";
export const paletteBrandCoral400 = "hsl(356, 100%, 48%)";
export const paletteBrandCoral500 = "hsl(356, 100%, 47%)";
export const paletteBrandCoral600 = "hsl(356, 100%, 46%)";
export const paletteBrandCoral700 = "hsl(356, 100%, 42%)";
export const paletteBrandCoral800 = "hsl(356, 100%, 34%)";
export const paletteBrandCoral900 = "hsl(356, 100%, 21%)";
export const paletteBrandCoral1000 = "hsl(356, 100%, 10%)";
export const paletteBrandGrey0 = "hsl(0, 0%, 100%)";
export const paletteBrandGrey25 = "hsl(0, 0%, 98%)";
export const paletteBrandGrey50 = "hsl(0, 0%, 95%)";
export const paletteBrandGrey100 = "hsl(0, 0%, 91%)";
export const paletteBrandGrey150 = "hsl(0, 0%, 86%)";
export const paletteBrandGrey200 = "hsl(0, 0%, 82%)";
export const paletteBrandGrey300 = "hsl(0, 0%, 72%)";
export const paletteBrandGrey400 = "hsl(0, 0%, 63%)";
export const paletteBrandGrey500 = "hsl(0, 0%, 53%)";
export const paletteBrandGrey600 = "hsl(0, 0%, 45%)";
export const paletteBrandGrey700 = "hsl(0, 0%, 35%)";
export const paletteBrandGrey800 = "hsl(0, 0%, 25%)";
export const paletteBrandGrey900 = "hsl(0, 0%, 16%)";
export const paletteBrandGrey1000 = "hsl(0, 0%, 7%)";
export const paletteSemanticBlue0 = "hsl(200, 100%, 99%)";
export const paletteSemanticBlue25 = "hsl(212, 100%, 95%)";
export const paletteSemanticBlue50 = "hsl(211, 96%, 90%)";
export const paletteSemanticBlue100 = "hsl(213, 98%, 82%)";
export const paletteSemanticBlue150 = "hsl(213, 97%, 77%)";
export const paletteSemanticBlue200 = "hsl(214, 97%, 72%)";
export const paletteSemanticBlue300 = "hsl(214, 94%, 65%)";
export const paletteSemanticBlue400 = "hsl(215, 92%, 60%)";
export const paletteSemanticBlue500 = "hsl(216, 88%, 56%)";
export const paletteSemanticBlue600 = "hsl(216, 82%, 52%)";
export const paletteSemanticBlue700 = "hsl(216, 84%, 46%)";
export const paletteSemanticBlue800 = "hsl(218, 73%, 39%)";
export const paletteSemanticBlue900 = "hsl(219, 63%, 26%)";
export const paletteSemanticBlue1000 = "hsl(220, 55%, 13%)";
export const paletteSemanticOrange0 = "hsl(0, 0%, 99%)";
export const paletteSemanticOrange25 = "hsl(43, 81%, 94%)";
export const paletteSemanticOrange50 = "hsl(42, 89%, 89%)";
export const paletteSemanticOrange100 = "hsl(41, 93%, 79%)";
export const paletteSemanticOrange150 = "hsl(40, 93%, 73%)";
export const paletteSemanticOrange200 = "hsl(39, 94%, 67%)";
export const paletteSemanticOrange300 = "hsl(38, 92%, 59%)";
export const paletteSemanticOrange400 = "hsl(37, 90%, 54%)";
export const paletteSemanticOrange500 = "hsl(36, 87%, 50%)";
export const paletteSemanticOrange600 = "hsl(35, 95%, 45%)";
export const paletteSemanticOrange700 = "hsl(34, 100%, 40%)";
export const paletteSemanticOrange800 = "hsl(38, 100%, 30%)";
export const paletteSemanticOrange900 = "hsl(43, 100%, 14%)";
export const paletteSemanticOrange1000 = "hsl(48, 100%, 1%)";
export const paletteSemanticGreen0 = "hsl(90, 100%, 100%)";
export const paletteSemanticGreen25 = "hsl(111, 58%, 95%)";
export const paletteSemanticGreen50 = "hsl(111, 57%, 91%)";
export const paletteSemanticGreen100 = "hsl(111, 51%, 84%)";
export const paletteSemanticGreen150 = "hsl(112, 47%, 77%)";
export const paletteSemanticGreen200 = "hsl(112, 45%, 71%)";
export const paletteSemanticGreen300 = "hsl(112, 40%, 60%)";
export const paletteSemanticGreen400 = "hsl(112, 35%, 51%)";
export const paletteSemanticGreen500 = "hsl(111, 42%, 42%)";
export const paletteSemanticGreen600 = "hsl(115, 41%, 37%)";
export const paletteSemanticGreen700 = "hsl(118, 40%, 31%)";
export const paletteSemanticGreen800 = "hsl(122, 37%, 26%)";
export const paletteSemanticGreen900 = "hsl(127, 34%, 21%)";
export const paletteSemanticGreen1000 = "hsl(130, 31%, 15%)";
export const paletteSemanticRed0 = "hsl(0, 100%, 99%)";
export const paletteSemanticRed25 = "hsl(0, 89%, 96%)";
export const paletteSemanticRed50 = "hsl(0, 88%, 94%)";
export const paletteSemanticRed100 = "hsl(0, 90%, 89%)";
export const paletteSemanticRed150 = "hsl(0, 90%, 84%)";
export const paletteSemanticRed200 = "hsl(0, 91%, 79%)";
export const paletteSemanticRed300 = "hsl(0, 89%, 70%)";
export const paletteSemanticRed400 = "hsl(0, 87%, 63%)";
export const paletteSemanticRed500 = "hsl(0, 84%, 56%)";
export const paletteSemanticRed600 = "hsl(0, 78%, 50%)";
export const paletteSemanticRed700 = "hsl(0, 86%, 44%)";
export const paletteSemanticRed800 = "hsl(5, 93%, 33%)";
export const paletteSemanticRed900 = "hsl(9, 98%, 19%)";
export const paletteSemanticRed1000 = "hsl(13, 100%, 7%)";
export const paletteDatavizBlue50 = "hsl(215, 89%, 89%)";
export const paletteDatavizBlue500 = "hsl(216, 89%, 55%)";
export const paletteDatavizOrange50 = "hsl(22, 100%, 87%)";
export const paletteDatavizOrange500 = "hsl(22, 100%, 50%)";
export const paletteDatavizGreen50 = "hsl(184, 49%, 83%)";
export const paletteDatavizGreen500 = "hsl(184, 100%, 32%)";
export const paletteDatavizRed50 = "hsl(355, 97%, 88%)";
export const paletteDatavizRed500 = "hsl(356, 98%, 51%)";
export const paletteDatavizPink50 = "hsl(323, 100%, 91%)";
export const paletteDatavizPink500 = "hsl(324, 100%, 64%)";
export const paletteDatavizPurple50 = "hsl(271, 51%, 86%)";
export const paletteDatavizPurple500 = "hsl(271, 68%, 43%)";
export const paletteBasicsBlack = "hsl(0, 0%, 0%)";
export const paletteBasicsWhite = "hsl(0, 0%, 100%)";
export const paletteBasicsWhite64 = "hsla(0, 0%, 100%, 0.64)";
export const fontFamilyUi = "Inter";
export const fontWeight300 = 300;
export const fontWeight400 = 400;
export const fontWeight500 = 500;
export const fontWeight600 = 600;
export const lineHeight100 = 1;
export const lineHeight200 = 1.3;
export const lineHeight300 = 1.5;
export const letterSpacingCondensed = "-0.2px";
export const letterSpacingDefault = 0;
export const letterSpacingWide = "0.2px";
export const spacing0 = 0;
export const spacing25 = 2;
export const spacing50 = 4;
export const spacing100 = 8;
export const spacing150 = 12;
export const spacing200 = 16;
export const spacing250 = 20;
export const spacing300 = 24;
export const spacing400 = 32;
export const spacing450 = 36;
export const spacing500 = 40;
export const spacing600 = 48;
export const spacing700 = 56;
export const spacing800 = 64;
export const spacing900 = 72;
export const spacing1000 = 80;
export const spacing1200 = 96;
export const borderRadius0 = 0;
export const borderRadius25 = 2;
export const borderRadius50 = 4;
export const borderRadius100 = 8;
export const borderRadius150 = 12;
export const borderRadius200 = 16;
export const borderRadius300 = 24;
export const borderRadiusRound = "50%";
export const borderRadiusBase = 8;
export const spacingBase = 8;
export const borderWidth0 = 0;
export const borderWidth100 = 1;
export const borderWidth200 = 2;
export const borderWidth300 = 3;
export const borderWidth800 = 8;
export const sizingBase = 8;
export const sizing50 = 4;
export const sizing75 = 6;
export const sizing100 = 8;
export const sizing200 = 16;
export const sizing300 = 24;
export const sizing400 = 32;
export const sizing500 = 40;
export const sizing550 = 44;
export const sizing600 = 48;
export const sizing700 = 56;
export const sizing800 = 64;
export const sizing900 = 72;
export const sizing1000 = 80;
export const sizing1200 = 96;
export const sizing1300 = 104;
export const opacity0 = 0;
export const opacity100 = 0.08;
export const opacity150 = 0.12;
export const opacity200 = 0.16;
export const opacity400 = 0.32;
export const opacity600 = 0.48;
export const opacity800 = 0.64;
export const opacity1000 = 1;
export const textDecorationNone = "none";
export const textDecorationUnderline = "underline";
export const highlightLarge = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":36,"letterSpacing":"-0.2px"};
export const highlightMedium = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":25,"letterSpacing":"-0.2px"};
export const highlightSmall = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.3,"fontSize":18,"letterSpacing":0};
export const titleLarge = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":22,"letterSpacing":0};
export const titleLargeStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.5,"fontSize":22,"letterSpacing":0};
export const titleMedium = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":20,"letterSpacing":0};
export const titleMediumStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.5,"fontSize":20,"letterSpacing":0};
export const titleSmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.3,"fontSize":18,"letterSpacing":0};
export const titleSmallStrong = {"fontFamily":"Inter","fontWeight":600,"lineHeight":1.3,"fontSize":18,"letterSpacing":0};
export const bodyLarge = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const bodyLargeStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":16,"letterSpacing":0};
export const bodyMedium = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const bodyMediumStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":14,"letterSpacing":0};
export const bodySmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1.5,"fontSize":12,"letterSpacing":0};
export const bodySmallStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1.5,"fontSize":12,"letterSpacing":0};
export const bodyExtraSmall = {"fontFamily":"Inter","fontWeight":400,"lineHeight":1,"fontSize":11,"letterSpacing":"0.2px"};
export const bodyExtraSmallStrong = {"fontFamily":"Inter","fontWeight":500,"lineHeight":1,"fontSize":11,"letterSpacing":"0.2px"};
